import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "./App.css";
import Home from "./landing-screen/home";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import LandingLayout from "./layouts/LandingLayout";
import DashboardLayout from "./layouts/DashboardLayout";
import DashboardHome from "./dashboard/Home";
import TermService from "./landing-screen/TermService";
import PrivacyPolicy from "./landing-screen/PrivacyPolicy";
import Register from "./landing-screen/Register";
import About from "./landing-screen/about";
import FAQPage from "./landing-screen/FAQ";
import HowItWorks from "./landing-screen/HowItWorks";
import ReferralPage from "./landing-screen/ReferralPage";
import SurveyPageCallback from "./landing-screen/surveypage";
import PersonalDetails from "./dashboard/PersonalDetails";
import Transaction from "./dashboard/Transaction";
import Referral from "./dashboard/Referral";
import SignOut from "./dashboard/SignOut";
import SurveyPage from "./dashboard/Survey";
import SurveyDetail from "./dashboard/SurveyDetail";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import Earnings from "./dashboard/Earnings";
import Reward from "./dashboard/Reward";
import Prescreener from "./dashboard/Prescreener";
import { useNavigate } from "react-router-dom";

import FeedbackPage from "./dashboard/Feedback";
import FeedbackSurveyDetail from "./dashboard/FeedbackSurveyDetail";

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

// Checks the stored JWT is present and not expired. This only controls
// which route shell renders client-side — the real security boundary is the
// backend rejecting unauthenticated API calls — but it stops the UI from
// treating a stale/expired session as logged in.
const hasValidToken = () => {
  try {
    const rawToken = localStorage.getItem("token");
    if (!rawToken) return false;
    const token = JSON.parse(rawToken);
    if (!token) return false;
    const decoded = jwtDecode(token);
    return !decoded.exp || decoded.exp * 1000 > Date.now();
  } catch (error) {
    return false;
  }
};

function AppContent() {
  const [isLoading, setIsLoading] = useState(true);
  const [isLoggedInres, setisLoggedInres] = useState(false);
  const authStatus = useSelector((state) => state.auth);
  const isLoggedIn = authStatus.isLoggedIn;
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const authData = urlParams.get("authData");

    if (authData) {
      try {
        const parsedAuthData = JSON.parse(decodeURIComponent(authData));
        if (parsedAuthData?.is_success) {
          localStorage.setItem("user", JSON.stringify(parsedAuthData));
          const token = parsedAuthData?.data?.token;
          localStorage.setItem("token", JSON.stringify(token));
          setisLoggedInres(true);
          navigate("/dashboard");
        }
      } catch (error) {
        console.error("Invalid authData in URL:", error);
      }
    } else {
      const storedAuthData = localStorage.getItem("user");
      let authDataObject = null;
      try {
        authDataObject = storedAuthData ? JSON.parse(storedAuthData) : null;
      } catch (error) {
        authDataObject = null;
      }

      if (authDataObject?.is_success && hasValidToken()) {
        setisLoggedInres(true);
      } else {
        setisLoggedInres(isLoggedIn && hasValidToken());
      }
    }

    setIsLoading(false);
  }, [isLoggedIn, navigate]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Routes>
      {isLoggedInres ? (
        <>
          <Route element={<DashboardLayout />}>
            <Route path="/dashboard" element={<DashboardHome />} />
            <Route path="/feedback" element={<FeedbackPage />} />
            <Route path="/feedback-survey/:surveyId" element={<FeedbackSurveyDetail />} />
            <Route path="/personal-details" element={<PersonalDetails />} />
            <Route path="/transaction" element={<Transaction />} />
            <Route path="/refer" element={<Referral />} />
            <Route path="/survey" element={<SurveyPage />} />
             <Route path="/survey/:surveyId" element={<SurveyDetail />} />
            <Route path="/passbook" element={<Earnings />} />
            <Route path="/earning" element={<Earnings />} />
            <Route path="/reward" element={<Reward />} />
            <Route path="/pre-screener" element={<Prescreener />} />
            <Route path="*" element={<Navigate to="/dashboard" />} />
             <Route path="/survey-callback" element={<SurveyPageCallback />} />
          </Route>
          {/* Standalone — deliberately outside DashboardLayout. SideNav's
              Points component fetches the profile on mount, which raced
              with logout clearing the token (401 → axios interceptor
              silently refreshes a new token mid-logout) and could spiral
              into "Maximum update depth exceeded". Sign-out needs nothing
              from the dashboard chrome anyway. */}
          <Route path="/sign-out" element={<SignOut />} />
        </>
      ) : (
        <Route element={<LandingLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/term-service" element={<TermService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/how-referral-works" element={<ReferralPage />} />
          {/* <Route path="/survey-callback" element={<SurveyPageCallback />} /> */}
          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      )}
    </Routes>
  );
}

export default App;
